const sections = {
    dashboard: "Dashboard",
    roster: "Roster",
    schedule: "Schedule",
    stats: "Stats",
    records: "Records",
};
export function getPublicTeamSection() {
    return sections[new URLSearchParams(window.location.search).get("view")?.toLowerCase() ?? ""] ?? "Dashboard";
}
export function getPublicTeamSeasonId() {
    return new URLSearchParams(window.location.search).get("season")?.trim() ?? "";
}
export function publicTeamSectionUrl(slug, section, seasonId = "") {
    const parameters = new URLSearchParams();
    if (section !== "Dashboard")
        parameters.set("view", section.toLowerCase());
    if (seasonId)
        parameters.set("season", seasonId);
    const query = parameters.toString();
    return `/teams/${encodeURIComponent(slug)}${query ? `?${query}` : ""}`;
}
